<template>
    <div>
        <div class="mt-5 centerLoadingBar" v-if="isLoadingData">
            <b-spinner type="grow" label="Spinning"></b-spinner>
        </div>
        <div v-else>
            <div class="divCenter">
                <h4 class="mb-3 lead">Amazon Upload vorbereiten</h4>
                <form>
                    <div class="p-2 bg-light">
                        <b-form-file
                                v-model="file1"
                                :state="Boolean(file1)"
                                placeholder="Datei auswählen"
                                @change="fileUploaded"
                                drop-placeholder="Drop file here..."
                        ></b-form-file>
                    </div>
                    <div v-if="fileJSON">
                        <b-button v-b-modal.modal-xl>Daten anzeigen</b-button>
                        <b-modal id="modal-xl" size="xl" v-bind:title="'Einträge vorhanden: ' + fileJSON.length">
                            <b-table :items="fileJSON" sticky-header borderless class="table table-condensed" striped
                                     hover/>
                        </b-modal>
                    </div>

                    <b-form-checkbox id="checkbox-1" class="float-left" v-model="isDemo">
                        Test Durchlauf
                    </b-form-checkbox>
                    <p class=" float-right"><small>Verfügbare EANS: {{eanAmount}}</small></p>


                    <div class="mt-5">
                        <b-dropdown text="Versandart auswählen" class="m-md-2 hl-dropdown">
                            <b-dropdown-item-button @click="shippingOptionChanged" :key="item + index"
                                                    v-for="(item, index) in shippingOptions">{{item}}
                            </b-dropdown-item-button>
                        </b-dropdown>
                        {{selectedShippingOption}}
                    </div>

                    <div>
                        <b-dropdown text="Material auswählen" class="m-md-2 hl-dropdown">
                            <b-dropdown-item-button @click="materialSelectionChanged" :key="item.materialName + index"
                                                    v-for="(item, index) in materials">{{item.materialName}}
                            </b-dropdown-item-button>
                        </b-dropdown>
                        {{selectedMaterialTxt}}
                    </div>

                    <div class="form-floating">
                        <b-form-input
                                id="input-live"
                                v-model="price"
                                placeholder="z.B. 6.95"
                                :state="formatPrice"
                                aria-describedby="input-live-help input-live-feedback"

                                trim
                        ></b-form-input>

                        <b-form-invalid-feedback id="input-live-feedback">
                            Bitte Preis angeben
                        </b-form-invalid-feedback>
                    </div>

                    <div class="mt-3" v-if="selectedMaterial._id">

                        <MaterialData :selected-material="selectedMaterial" :uploadSizes="upload_sizes"/>

                    </div>

                    <button v-if="!itemLines || itemLines.length === 0" class="w-25  btn btn-dark mt-4 " @click.prevent="create">Create</button>
                    <div v-if="invalidSKUItemLines">
                        <div v-for="(item, index) in invalidSKUItemLines" :key="item">
                            <input v-if="item.item_sku.length > 40"
                                   class="sku-input form-control is-invalid"
                                   @keyup="(event) => onSkuChanged(event, item)"
                                   v-model="invalidSKUItemLines[index].item_sku"/>

                            <input v-else
                                   class="sku-input form-control is-valid"
                                   @input="(event) => onSkuChanged(event, item)"
                                   v-model="invalidSKUItemLines[index].item_sku"/>
                        </div>
                    </div>
                    <button
                            @click.prevent="downloadFile"
                            v-if="itemLines && itemLines.length >= 0"
                            class="w-25 btn btn-dark mt-4 mb-3"
                            v-b-tooltip.hover
                            v-b-modal.modal-deleteMaterial
                            title="Material löschen"><b-icon icon="download"/> Download File</button>




                </form>


            </div>
        </div>
    </div>


</template>


<script>

    import XLSX from 'xlsx'
    import Api from './api'
    import MaterialData from './components/MaterialData'

    import {createItemLines, createParentLine, convertItemsToArray, updateEANsInDatabase} from "./utils";

    export default {
        components:{
            MaterialData
        },
        data() {
            return {
                materials: [],
                upload_sizes: {},
                file1: null,
                fileJSON: undefined,
                shippingOptions: [],
                selectedMaterialTxt: "",
                selectedMaterial: {},
                invalidSKUItemLines: [],
                selectedShippingOption: "",
                parentSKU: "",
                itemLines: undefined,
                isDemo: false,
                globalWorkbook : {},
                isLoadingData: false,
                price: '',
                test_model: '',
                eanAmount: '',
                columns:
                    [
                        {
                            key:'item_sku',
                            label:"SKU"

                        },
                        {
                            key: 'size_name',
                            label:"Größe (Modell)"
                        },
                        {
                            key: 'color_name',
                            label:"Farbe (Motiv)"
                        },
                        {
                            key: 'purchasable_offer[marketplace_id=A1PA6795UKMFR9]#1.our_price#1.schedule#1.value_with_tax',
                            label: "Preis"
                        },
                        {
                            key: 'quantity',
                            label:"Anzahl",

                        }
                         ]
            }
        },
        computed: {
            formatPrice() {

                return this.price.length>0
                // return this.itemLines[0].item_sku.length < 25 ? true : false
            }
        },

        methods: {

            onSkuChanged(event, changedItem){
                const item = this.itemLines.find(item => item === changedItem)
                if(item.model)
                    item.model = item.item_sku
                if(item.model_name)
                    item.model_name = item.item_sku
                if(item.part_number)
                    item.part_number = item.item_sku

            },

            makeToast(variant = null, body = '', title = '') {
                this.$bvToast.toast(body, {
                    title: title,
                    variant: variant,
                    solid: true
                })
            },

            materialSelectionChanged(e) {

                this.selectedMaterialTxt = e.target.outerText;
                this.selectedMaterial = this.materials.find(item => item.materialName == this.selectedMaterialTxt)
                this.parentSKU = this.selectedMaterial.parentSKU
            },

            shippingOptionChanged(e) {
                this.selectedShippingOption = e.target.outerText;
            },

            checkEANAmount(){
                if(this.fileJSON.length > this.eanAmount){
                    throw new Error("Nicht genug EANS vorhanden")
                }
            },

            create() {
                try {
                    if(this.isDemo === false){
                        this.checkEANAmount()
                    }
                    this.isLoadingData = true
                    const basisData = {
                        // feed_product_type: "cellularphonecase",
                        quantity: 1,
                        brand_name: "Handy Lux",
                        parent: "Parent",
                        child: "Child",
                        relationship_type: "Variation",
                        update_delete: "Aktualisierung",
                        update_delete_partiel: "Partielle Aktualisierung",
                        condition: "Neu",
                        external_product_id_type: "EAN",
                        country_of_origin: "Deutschland",
                        fulfillment_latency: 1,
                        offering_can_be_gift_messaged: "TRUE", //TODO
                        "fulfillment_channel_code": "DEFAULT" //TODO
                    };


                    var that = this;


                    // debugger//eslint-disable-line no-debugger

                    let parentLine = createParentLine(basisData, this.selectedMaterial)
                    createItemLines(basisData, this.fileJSON, this.selectedMaterial, this.selectedShippingOption, this.isDemo, this.price, this.upload_sizes)
                        .then(x => {
                            x.unshift(parentLine)
                            that.itemLines = x;
                            that.invalidSKUItemLines = x.filter((line) => line.item_sku.length > 40)
                            // debugger//eslint-disable-line no-debugger
                            that.isLoadingData = false
                        }).catch(e => {
                        this.makeToast('danger', "Fehler: " + e.message, "Fehler beim Laden")
                        that.isLoadingData = false
                    });
                }catch (e) {
                    this.makeToast('danger', "Fehler: " + e.message, "Fehler beim Erstellen")
                    this.isLoadingData = false
                }
            },

            downloadFile(){
                 let that = this;
                let reader = new FileReader();
                reader.addEventListener("load", e => {
                    let workbook = XLSX.read(e.target.result, {type: 'binary'})
                    workbook.SheetNames.forEach(function (sheetName) {

                        let fileJSON = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName], {
                            range: 2,
                            blankrows: true,
                            defval: ""
                        });

                        let resultJSON = []
                        // debugger//eslint-disable-line no-debugger
                        for (let item of that.itemLines) {
                            let currObj = {}
                            Object.assign(currObj, fileJSON[0])
                            let keys = Object.keys(item);

                            for (let key of keys) {
                                currObj[key] = item[key];

                            }
                            resultJSON.push(currObj)
                        }
                        debugger//eslint-disable-line no-debugger

                        XLSX.utils.sheet_add_json(workbook.Sheets[sheetName], resultJSON, {origin: "A3"})
                        XLSX.writeFile(workbook, 'export.txt', {bookType:"csv", FS:"\t", type: "string"});
                        debugger//eslint-disable-line no-debugger

                        updateEANsInDatabase(that.itemLines)

                    })
                })
                Api.download.downloadTemplateFile()
                .then(response => {
                    return response.data
                })
                .then(blob => {
                    debugger // eslint-disable-line no-debugger
                    var file = new File([blob], `UPLOAD.xlsx`);
                    reader.readAsBinaryString(file)
                    that.isLoadingData = false


                }).catch(e => {
                    this.makeToast('danger', "Fehler: " + e.message, "Fehler beim Laden")
                    that.isLoadingData = false
                });

            },

            fileUploaded(e) {
                try {


                    let file = e.currentTarget.files ? e.currentTarget.files[0] : e.dataTransfer.files[0];
                    if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls") && !file.name.endsWith(".xlsm") && !file.name.endsWith(".csv")) {
                        throw new Error("Falsches format! Erwartet: .xlsx .xls .xlsm .csv")
                    }

                    let reader = new FileReader();
                    const that = this;
                    reader.addEventListener("load", e => {
                        // let items = []
                        let workbook = XLSX.read(e.target.result, {type: 'binary'})
                        workbook.SheetNames.forEach(function (sheetName) {
                            console.log(XLSX.utils)
                            that.fileJSON = convertItemsToArray(XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]))

                            that.makeToast('success', "Datei erfolgreich gelesen.", "Erfolgreich gelesen")
                        })

                    });
                    reader.readAsBinaryString(file)
                } catch (e) {
                    this.makeToast('danger', e.message ? e.message : "Fehler", "Fehler beim Lesen")
                }
            }
        },

        beforeMount() {
            const that = this
            this.isLoadingData = true
            let jwt = this.$cookies.get("authToken")
            Api.auth.verify({authToken: jwt})
                .then(response => {
                    if (response.status == 200) {
                        this.$store.commit('setUser', true)
                        Api.init(jwt)
                    }
                    Api.materials.getMaterials()
                        .then(response => response.data)
                        .then(data => {
                            that.materials = data
                            return Api.shippingOptions.getShippingOptions()
                        })
                        .then(response => response.data)
                        .then(data => {
                            that.shippingOptions = data.shippingOptions
                            return Api.ean.countEANs()
                            })
                        .then(result => result.data)
                        .then(eanList => {
                            that.eanAmount = eanList.length
                            return Api.upload_sizes.getAllSizes()
                        })
                        .then(res => res.data)
                        .then(res => {
                            that.upload_sizes = res
                            this.isLoadingData = false
                        })
                })
                .catch(() => {
                    this.isLoadingData = false
                    this.$store.commit('setUser', false)
                    this.$router.push({path: '/'})
                })
        }

    }
</script>

<style>
    .hl-dropdown {
        width: 200px;
    }

    .divCenter {
        padding-top: 20px;
        margin-left: 30%;
        margin-right: 30%;
    }

    .centerLoadingBar{
        text-align: center;

    }


    .table-condensed {
        font-size: 12px;
    }

    .sku-input{
        margin-top: 5px;
        margin-bottom: 5px;
    }

</style>
